export const pluralize = (count, noun, suffix = 's') => {
  return `${count} ${noun}${Math.abs(count) !== 1 ? suffix : ''}`;
};

export const toTitleCase = string =>
  string
    ? string.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
    : '';
